import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./pages/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// color (#E8CDCC) for background
// Brittany font for name (color #a87526)
// Poppins font for text (invite you to join our wedding celebration on)
